"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("horizontal-bar", require("./InBodyHorizontalBar.vue").default);

exports.default = {
  props: ["answers"]
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/tests/InBody/ShowInBodyTest.vue
// module id = N9uk
// module chunks = 0 1